module.exports = __webpack_public_path__ + "media/images/games/fifa-23/square-ffcaf7b77ddd2aeedd3d3109c0b2507b.jpg";